import React from 'react';
import './App.css';
import Container from './Component/Container';

function App() {
  return (
   <>
     <Container />
   </>
  );
}

export default App;
